import React from "react";
import "./pagefooter.css";
import { Helmet } from "react-helmet-async";

const CancellationPolicy = () => (
  <>
    <Helmet>
      <title>Cancellation Policy | AIKYAM Sports Science</title>

      <meta
        name="description"
        content="Read AIKYAM Sports Science's cancellation policy for product orders, sports services, physiotherapy appointments, refunds, and booking cancellations."
      />

      <meta
        name="keywords"
        content="AIKYAM Cancellation Policy, Sports Science Cancellation, Physiotherapy Cancellation, Booking Cancellation"
      />

      <link
        rel="canonical"
        href="https://aikyamsports.com/cancellation-policy"
      />

      {/* Open Graph */}
      <meta
        property="og:title"
        content="Cancellation Policy | AIKYAM Sports Science"
      />

      <meta
        property="og:description"
        content="Learn about AIKYAM Sports Science's cancellation policy for products, appointments, and services."
      />

      <meta
        property="og:url"
        content="https://aikyamsports.com/cancellation-policy"
      />

      <meta
        property="og:type"
        content="website"
      />

      <meta
        property="og:image"
        content="https://aikyamsports.com/logo11.png"
      />

      {/* Twitter */}
      <meta
        name="twitter:card"
        content="summary_large_image"
      />

      <meta
        name="twitter:title"
        content="Cancellation Policy | AIKYAM Sports Science"
      />

      <meta
        name="twitter:description"
        content="Review AIKYAM Sports Science's cancellation policy for products and sports services."
      />

      <meta
        name="twitter:image"
        content="https://aikyamsports.com/logo11.png"
      />
    </Helmet>

    <div className="policy-page">
      <h1>Cancellation Policy</h1>

      <p>
        We understand that plans can change. Please review our
        cancellation policy below:
      </p>

      <ul>
        <li>
          <strong>Product Orders:</strong> Orders can be cancelled
          before they are shipped. Once shipped, cancellations are
          not possible.
        </li>

        <li>
          <strong>Service Bookings:</strong> Service appointments can
          be cancelled up to 24 hours before the scheduled time for a
          full refund.
        </li>

        <li>
          <strong>How to Cancel:</strong> Contact us at
          +91 6363202281 or +91 7019386664 to request a cancellation.
        </li>

        <li>
          <strong>Refunds:</strong> Approved cancellations will be
          refunded according to our Refund Policy.
        </li>
      </ul>

      <p>
        <strong>Location:</strong><br />
        Center for Sports Science,<br />
        Mahatma Gandhi Stadium,<br />
        Ajjarakad, Brahmagiri,<br />
        Udupi, Karnataka – 576101
      </p>
    </div>
  </>
);

export default CancellationPolicy;